module.exports = __webpack_public_path__ + "img/142.470b0c61.jpg";